import { RECOGNIZE_PLATFORMS } from "@redotech/redo-customer-common/recognize/audience-metrics";
import * as z from "zod";

/**
 * Recognize shopper — a flattened view of the reveal engine's RevealResponse.profile.
 */

export const PlatformAudience = z.object({
  platform: z.enum(RECOGNIZE_PLATFORMS),
  /** null = profile found but the count is not public. Never 0. */
  followers: z.number().nullable(),
});
export type PlatformAudience = z.infer<typeof PlatformAudience>;

export const RecognizeMediaMention = z.object({
  type: z.enum(["podcast", "article", "video"]),
  title: z.string(),
  outlet: z.string(),
  date: z.string(),
});
export type RecognizeMediaMention = z.infer<typeof RecognizeMediaMention>;

export const RecognizeShopper = z.object({
  customerId: z.string(),
  name: z.string(),
  /** Career.currentTitle + currentCompany, condensed for a list row. */
  headline: z.string().nullable(),
  /** Career.synopsis — the paragraph that says who this person is. */
  synopsis: z.string().nullable(),
  badges: z.array(z.string()),
  /** Profile.age — the reveal engine does not derive this yet. */
  age: z.number().nullable(),
  /** Profile.gender — inferred, low confidence. */
  gender: z.enum(["male", "female"]).nullable(),
  state: z.string().nullable(),
  city: z.string().nullable(),
  /** PropertyData.homeMarketValue. */
  homeMarketValue: z.number().nullable(),
  isVip: z.boolean(),
  /** Why this shopper matches the merchant's configurable VIP standards. */
  vipReason: z.string().nullable(),
  orders: z.number(),
  lastOrderAt: z.string().nullable(),
  /**
   * RevealResponse.confidenceBand — reveal confidence, not the
   * restriction_confidence DB enum whose value set it coincidentally matches.
   */
  //redontIgnore
  confidenceBand: z.enum(["high", "medium", "low"]),
  audiences: z.array(PlatformAudience),
  media: z.array(RecognizeMediaMention),
  /** Provenance.sources — cited URLs / provider names behind this profile. */
  sources: z.array(z.string()),
});
export type RecognizeShopper = z.infer<typeof RecognizeShopper>;

export const getRecognizeShoppers = {
  name: "getRecognizeShoppers" as const,
  input: z.object({}),
  output: z.object({ shoppers: z.array(RecognizeShopper) }),
};
